import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from "../services/configuration.service";
import { Router } from "@angular/router";
import { UserService } from "../services/user.service";
import { BankService } from "../services/bank.service";
import { PagerserviceService } from "../services/pagerservice.service";
import { NotificationsService } from "angular2-notifications";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import * as XLSX from 'xlsx';
import { APP_CONSTS } from '../consts/app.consts';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';

const defaults = {
    notify: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
    }
}
@Component({
    selector: 'app-withdraw',
    templateUrl: './withdraw.component.html',
    styleUrls: ['./withdraw.component.css']
})
export class WithdrawComponent implements OnInit {
    /*store all transaction list variable*/
    withdrawlist: Array<any>;
    /* Search variables */
    FilPerpage: number;
    FilPage: number;
    filter: Boolean;
    /************************************/
    // pager Number
    pager: number;
    Tpager: number;
    public settings: any
    // pager object
    pager1: any = {};
    withdrawalllist: any = [];
    manualPosition = {
        reason: '',
        hidden: '',
        createdAt: new Date(),
        _csrf: '',
        status: ''
    }
    searchObj = {
        time1: new Date(),
        time: new Date(),
        search: ''
    }
    // search : ''
    //search option
    statusoption = '';
    permission: string;
    customer: Boolean;
    fileName: string;
    currentPage = 0;
    withdrawlistexport = [];
    csrf_token: any = '';
    autoWithdraw: Boolean = true;

    constructor(private router: Router,
        private configService: ConfigurationService,
        private userService: UserService,
        private bankService: BankService,
        private pagerService: PagerserviceService,
        private spinnerService: Ng4LoadingSpinnerService,
        private notifSer: NotificationsService,
        private dialog: MatDialog
    ) { }


    ngOnInit() {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            if (typeof localStorage.getItem('adminmenus') != 'undefined' && localStorage.getItem('adminmenus').length > 0) {
                var spt = this.router.url.split("/");
                var menu_url = spt[1];
                var adminmenus = JSON.parse(localStorage.getItem('adminmenus'));
                var adminrules = JSON.parse(localStorage.getItem('adminrules'));
                var index = adminmenus.findIndex(x => (x.menu_url) === menu_url);
                if (index != -1) {
                    var menuid = adminmenus[index]._id;
                    var adindex = adminrules.findIndex(x => (x.menu_id) === menuid.toString());
                    this.permission = (adindex != -1) ? adminrules[adindex].permission : "write";
                }
            }
            this.customer = false;
            this.FilPerpage = 10;
            this.FilPage = 1;
            this.pager = 1;
            this.getWithdrawList();
            this.getAdminSettings();
            this.csrf();
        }
    }

    csrf() {
        this.userService.csrf().subscribe((success) => {
            this.manualPosition._csrf = success._csrf;
            this.csrf_token = success._csrf;
        }, (error) => {
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    singleScheduledWithdraw(data) {
        this.dialog.open(ConfirmationDialogComponent, {
            data: {
                message: `Are you sure want to withdraw?`,
                buttonText: {
                    ok: 'Yes',
                    cancel: 'No'
                }
            }
        }).afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                const { notify } = defaults;
                var obj = {
                    _csrf: this.csrf_token,
                    _id: data._id
                }
                this.bankService.crypto_scheduled_withdraw(obj).subscribe((success) => {
                    this.spinnerService.hide();
                    this.getWithdrawList();
                    this.notifSer.success(
                        'Scheduled exchange withdrawal',
                        success.message,
                        notify
                    )
                }, err => {
                    this.notifSer.error(
                        'Scheduled exchange withdrawal',
                        err.error.message,
                        notify
                    )
                });
            }
        });
    }
    singleExchangeWithdraw(data) {
        this.dialog.open(ConfirmationDialogComponent, {
            data: {
                message: `Are you sure want to withdraw?`,
                buttonText: {
                    ok: 'Yes',
                    cancel: 'No'
                }
            }
        }).afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                const { notify } = defaults;
                var obj = {
                    _csrf: this.csrf_token,
                    _id: data._id
                }
                this.bankService.exchange_withdrawal(obj).subscribe((success) => {
                    this.spinnerService.hide();
                    this.getWithdrawList();
                    this.notifSer.success(
                        'Crypto exchange withdrawal',
                        success.message,
                        notify
                    )
                }, err => {
                    this.notifSer.error(
                        'Crypto exchange withdrawal',
                        err.error.message,
                        notify
                    )
                });
            }
        });
    }
    getWithdrawList() {
        this.spinnerService.show();
        this.bankService.getWithdrawList(this.FilPerpage, this.FilPage, this.searchObj, false).subscribe((success) => {
            this.spinnerService.hide();
            if (success.status) {
                this.withdrawlist = success.withdraw.map((item) => {
                    // Add a new property "displayRejectButton" based on the "status"
                    item.displayRejectButton = item.status === 'SCHEDULED';
                    return item;
                  });
                this.Tpager = success.pages;
                this.currentPage = success.current;
                this.setPage(this.FilPage);
            }
        }, (error) => {
            this.withdrawlist = [];
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    shouldDisplayRejectButton(status: string): boolean {
        return status === 'SCHEDULED';
      }
    getWithdrawListexp() {
        this.spinnerService.show();
        this.bankService.getWithdrawList(this.FilPerpage, this.FilPage, this.searchObj, true).subscribe((success) => {
            this.spinnerService.hide();
            if (success.status) {
                this.withdrawalllist = success.withdraw;
                this.withdrawlistexport = [];
                for (let i = 0; i < this.withdrawalllist.length; i++) {
                    this.withdrawlistexport.push({
                        'Date': this.withdrawalllist[i].createdAt ? this.withdrawalllist[i].createdAt : '',
                        'Legal Name': this.withdrawalllist[i].user.name ? this.withdrawalllist[i].user.name : '',
                        'Email': this.withdrawalllist[i].user.email ? this.withdrawalllist[i].user.email : '',
                        'Destination Address': this.withdrawalllist[i].address ? this.withdrawalllist[i].address : '',
                        'Currency': this.withdrawalllist[i].currency ? this.withdrawalllist[i].currency : '',
                        'Asset ID': this.withdrawalllist[i].assetid ? this.withdrawalllist[i].assetid : '',
                        'Amount': this.withdrawalllist[i].amount ? this.withdrawalllist[i].amount : '',
                        'Fee': this.withdrawalllist[i].withdraw_fee ? this.withdrawalllist[i].withdraw_fee : '',
                        'Transfer Amount': this.withdrawalllist[i].transfer_amount ? this.withdrawalllist[i].transfer_amount : this.withdrawalllist[i].amount,
                        'Txn type': this.withdrawalllist[i].txntype ? this.withdrawalllist[i].txntype : 'Automatic',
                        'TxnID':  this.withdrawalllist[i].txnid ? this.withdrawalllist[i].txnid : '',
                        'Note': this.withdrawalllist[i].note ? this.withdrawalllist[i].note : '',
                        'Status': this.withdrawalllist[i].status ? this.withdrawalllist[i].status : '',
                        'Authorized By': this.withdrawalllist[i].adminid ? this.withdrawalllist[i].adminid : '',
                    })
                }
                this.fileName = 'WithdrawReport.xlsx'
                const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.withdrawlistexport);

                /* generate workbook and add the worksheet */
                const wb: XLSX.WorkBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

                /* save to file */
                XLSX.writeFile(wb, this.fileName);
            }
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    exchangeWithdrawal() {
        var obj = {_csrf: this.csrf_token}
        this.bankService.exchange_withdrawal(obj).subscribe((success) => {
            this.spinnerService.hide();
            this.getWithdrawList();
            this.notifSer.success(
                'Crypto exchange withdrawal',
                success.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        });
    }
    cryptoScheduledWithdraw() {
        var obj = {_csrf: this.csrf_token}
        this.bankService.crypto_scheduled_withdraw(obj).subscribe((success) => {
            this.spinnerService.hide();
            this.getWithdrawList();
            this.notifSer.success(
                'Crypto Scheduled Withdraw',
                success.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        });
    }
    cancelwithdraw(depositId, status) {
        this.manualPosition.hidden = depositId;
        this.manualPosition.status = "cancel";
        this.bankService.withdraw_process(this.manualPosition).subscribe((success) => {
            this.spinnerService.hide();
            this.manualPosition.hidden = '';
            this.manualPosition.reason = '';
            this.getWithdrawList();
            this.notifSer.success(
                'Cancel Withdraw',
                success.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        });
    }

    Submitreason() {
        this.manualPosition.status = "cancel";
        this.bankService.withdraw_process(this.manualPosition).subscribe((success) => {
            this.spinnerService.hide();
            this.manualPosition.hidden = '';
            this.manualPosition.reason = '';
            this.getWithdrawList();
            this.notifSer.success(
                'Cancel Withdraw',
                success.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        });
    }

    approveWithdraw(withdraw) {
        this.spinnerService.show();
        var obj = {
            _id: withdraw._id,
            status: "confirm",
            currency: withdraw.currency,
            _csrf: this.csrf_token
        }
        this.bankService.withdraw_process(obj).subscribe((success) => {
            this.spinnerService.hide();
            this.getWithdrawList();
            if (success.status) {
                this.notifSer.success(
                    'Approve Withdraw',
                    success.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            }
            else {
                this.notifSer.error(
                    'Approve Withdraw',
                    success.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            }

        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Approve Withdraw',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    updateWithdraw(trans,status) {
        this.spinnerService.show();
        let finalStatus=(status)?APP_CONSTS.TRANSACTION_STATUS.APPROVED:APP_CONSTS.TRANSACTION_STATUS.REJECTED;

        var obj = {
            _id: trans._id,
            status: finalStatus,
            currency: trans.currency,
            userid: trans.userid,
            _csrf: this.csrf_token
        }
        this.bankService.withdraw_process(obj).subscribe((data) => {
            this.spinnerService.hide();
            this.getWithdrawList();
            this.notifSer.success('Success', data.message, {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            });
        }, (err) => {
            this.spinnerService.hide();
            this.notifSer.error(err.error.message);
        })
    }

    SearchWithdrawStatus(target) {
        this.spinnerService.show();
        this.statusoption = target.target.value;
        this.bankService.getWithdrawList(this.FilPerpage, this.FilPage, this.statusoption, false).subscribe((success) => {
            if (success.status) {
                this.withdrawlist = success.withdraw;                
                this.Tpager = success.pages;
                this.setPage(this.FilPage);
            }
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    SearchWithdraw(target) {
        this.spinnerService.show();
        this.searchObj.search = target.target.value;
        this.bankService.getWithdrawList(this.FilPerpage, this.FilPage, this.searchObj, false).subscribe((success) => {
            if (success.status) {
                this.withdrawlist = success.withdraw;
                this.Tpager = success.pages;
                this.setPage(this.FilPage);
                this.withdrawlistexport = [];
                for (let i = 0; i < this.withdrawlist.length; i++) {
                    if (this.withdrawlist[i].status == 'Approved') {
                        this.withdrawlist[i].status = 'Approved';
                    } else if (this.withdrawlist[i].status == 'Mail') {
                        this.withdrawlist[i].status = 'UserPending';
                    } else if (this.withdrawlist[i].status == 'Pending') {
                        this.withdrawlist[i].status = 'AdminPending'
                    } else if (this.withdrawlist[i].status == 'Rejected') {
                        this.withdrawlist[i].status = 'UserRejected'
                    } else if (this.withdrawlist[i].status == 'Cancelled') {
                        this.withdrawlist[i].status = 'AdminCancelled'
                    } else if (this.withdrawlist[i].status == 'Admin-Inputted') {
                        this.withdrawlist[i].status = 'Admin-Inputted'
                    } else {
                    }
                    var txn_id = '';
                    if (this.withdrawlist[i].txntype == "Automatic") {
                        txn_id = this.withdrawlist[i].txnid ? this.withdrawlist[i].txnid : 'N/A'
                    }
                    else {
                        txn_id = this.withdrawlist[i].transactionid ? this.withdrawlist[i].transactionid : 'N/A';
                    }
                    this.withdrawlistexport.push({
                        'Date': this.withdrawlist[i].createdAt ? this.withdrawlist[i].createdAt : 'N/A',
                        'Legal Name': this.withdrawlist[i].user.name ? this.withdrawlist[i].user.name : 'N/A',
                        'Email': this.withdrawlist[i].user.email ? this.withdrawlist[i].user.email : 'N/A',
                        'Destination Address': this.withdrawlist[i].address ? this.withdrawlist[i].address : 'N/A',
                        'Currency': this.withdrawlist[i].currency ? this.withdrawlist[i].currency : 'N/A',
                        'Amount': this.withdrawlist[i].amount ? this.withdrawlist[i].amount : 'N/A',
                        'Fee': this.withdrawlist[i].withdraw_fee ? this.withdrawlist[i].withdraw_fee : 'N/A',
                        'Transfer Amount': this.withdrawlist[i].transfer_amount ? this.withdrawlist[i].transfer_amount : this.withdrawalllist[i].amount,
                        'Txn type': this.withdrawlist[i].txntype ? this.withdrawlist[i].txntype : 'Automatic',
                        'Note': this.withdrawlist[i].note ? this.withdrawlist[i].note : 'N/A',
                        'TxnID': txn_id,
                        'Status': this.withdrawlist[i].status ? this.withdrawlist[i].status : 'N/A',
                        'Authorized By': this.withdrawlist[i].adminid ? this.withdrawlist[i].adminid : 'N/A',
                    })
                }
            }
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page: number) {
        this.pager = page;
        this.FilPage = this.pager;
        this.getWithdrawList();
    }
    /**
    * 
    * @param report export excel
    */
    exportExcel(report) {
        this.fileName = 'WithdrawReport.xlsx'
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.withdrawlistexport);

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, this.fileName);
    }
    showApproveRejectButton(trans){
        return trans.status==APP_CONSTS.TRANSACTION_STATUS.PENDING
    }

    getAdminSettings() {
        this.configService.getAdminSettings().subscribe(adminSetting => {
          this.autoWithdraw = adminSetting.result[0].auto_withdraw;
        });
    }
    
    updateAutoWithdraw() {
        this.configService.updateAdminSettings({_csrf: this.csrf_token,autoWithdraw:!this.autoWithdraw}).subscribe(result => {
            this.autoWithdraw = result.auto_withdraw;
            this.notifSer.success(
            'Status',
            'Auto Withdraw Settings Updated',
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
            )
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
            'Status',
            error.error.message,
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
            )
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/withdraw/withdraw.component.ts